/*
* @Description: ""
* @Author: YOYO 792611446@qq.com
 * @LastEditors: ChangWenBo (649160016@qq.com)
* @Date:   2019-04-18 17:25:40
 * @LastEditTime: 2021-04-02 15:39:14
*/
import request from '@/utils/request'
// import { getServiceCode } from '@/cont.js'
// const areaCode = getServiceCode(process.env.VUE_APP_REGIONAL)
// 产品列表分页查询
const productslistUrl = '/rest/base/products/page'
// 新增产品
const productssaveUrl = '/rest/base/products/save'
// 根据字典类型查询字典列表
const listDictByTypeUrl = '/rest/base/dict/listDictByType'

/**
 * @description: 产品列表分页查询
 * @param        {object} params 请求接口参数：pageNo='页码'，pageSize='每页条数'
 * @return       {object} res
 */
export async function getProductslist (params) {
  return request.get(productslistUrl, {
    ...params,
  })
}

/**
 * @description: 删除产品信息
 * @param        {object} params id='客户主键'
 * @return       {object} res
 */
export async function deleteProducts (params) {
  return request.post(`/rest/base/products/${params}/del`, {
    ...params,
  })
}

/**
 * @description: 保存客户信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function saveProduct (params) {
  return request.post(productssaveUrl, {
    ...params,
  }, {}, 2)
}
/**
 * @description: 客户管理列表分页查询
 * @param        {object} params 请求接口参数：type='字典类型'
 * @return       {object} res
 */
export async function getlistDictByType (params) {
  return request.get(listDictByTypeUrl, {
    ...params,
  })
}
/**
 * @description: 产品详情
 * @param        {object} params id='客户主键'
 * @return       {object} res
 */
export async function productDetail (params) {
  return request.get(` /rest/base/products/${params}/detail`, {
    ...params,
  })
}
/**
 * @description: 更新产品信息
 * @param        {object} 请求接口参数：code='代码'name='名称' shortName='简称'region='所属大区
 * @return       {object} res
 */
export async function updateProduct (params) {
  return request.post(` /rest/base/products/${params.id}/update`, {
    ...params,
  }, {}, 2)
}
